import React from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import imgs from '../img/logo512.png';

export default function LeftSidebar({ isSidebarOpen, toggleSidebar }) {
    const location = useLocation();
    return (
        <>
            <ul className={isSidebarOpen ? 'navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled' : 'navbar-nav bg-gradient-primary sidebar sidebar-dark accordion'} id="accordionSidebar">
                <Link className="sidebar-brand d-flex align-items-center justify-content-center mt-3" to="/member" >
                    <div className='row'>
                        <div className='col-md-10'>
                            <div className="sidebar-brand-text-img">
                                <img 
                                className="img-profile rounded-circle" 
                                src={imgs} 
                                alt="Profile"
                                style={{ height: '85px', width: '100px' }} 
                                />
                            </div>
                        </div>
                    </div>
                </Link>
                <hr className="sidebar-divider my-0" />
                <li className={`nav-item ${location.pathname === '/member' ? 'active' : ''}`} >
                    <Link className="nav-link" to="/member">
                        <i className="fas fa-fw fa-home"></i>
                        <span>Dashboard</span>
                    </Link>
                </li>
                
                
               
                <li className={`nav-item ${location.pathname === '/profile_edit' ? 'active' : ''}`} >
                    
                    <Link className="nav-link" to="/profile_edit">
                        <i className="fas fa-fw fa-user"></i>
                        <span>Manage Profile </span>
                    </Link>
                </li>
               
                {/*<li className={`nav-item ${location.pathname === '/receipt' || location.pathname === '/members/receipt' ? 'active' : ''}`} >
                    
                    <Link className="nav-link" to="/members/receipt">
                    <i className="fas fa-fw fa-file-word-o"></i>
                    <span>Download Receipt</span>
                    </Link>
                </li> */}
                <li className={`nav-item ${location.pathname === '/members/payments' ? 'active' : ''}`} >
                    
                    <Link className="nav-link" to="/members/payments">
                    <i className="fas fa-fw fa-credit-card"></i>
                    <span>Payments</span>
                    </Link>
                </li>
              
                <li className={`nav-item ${location.pathname === '/change-member-password' ? 'active' : ''}`} style={{marginTop:'-10px'}}>
                    <Link className="nav-link" to="/change-member-password">
                        <i className="fas fa-pencil-square-o"></i>
                        <span>Change Password</span>
                    </Link>
                </li>
                <hr className="sidebar-divider d-none d-md-block" />
                <div className="row">
                    <div className='col-md-12 d-flex justify-content-center '>
                        <div className="text-center d-none d-md-inline">
                            <button className="rounded-circle border-0" id="sidebarToggle" onClick={toggleSidebar}></button>
                        </div>
                    </div>
                </div>
            </ul>
        </>

    )
}
